export default __webpack_public_path__ + "static/media/health_pass.b7c142d5.svg";